import React from 'react';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import { setCommas } from '@common/utils/kbValidation';
import { getDateByformat } from '@common/utils/date';
import { useDispatch } from 'react-redux';
import { toCurrency } from '@common/utils';
// import { parse, isSameYear, isSameMonth, isSameDay, getHours } from 'date-fns';

const kbOmniLable = {
  '01': '계약자 작성 중',
  '02': '청약 접수 완료',
  '03': '작성 미완료',
};

const MobileOmniList = props => {
  const {
    mobileOmniList,
    onClickSortBtn,
    // currentDate,
    onScroll,
    searchParams,
    clickListEvent,
  } = props;
  const dispatch = useDispatch();
  const columns = [
    {
      title: '청약일자',
      dataIndex: 'sendDate',
      key: 'sendDate',
      sortable: true,
      width: '15',
      render: value => (
        <span className="t-date small">
          {getDateByformat(value, 'yyyy.MM.dd')}
        </span>
      ),
    },
    {
      title: '진행 상태',
      dataIndex: 'proccessStatus',
      key: 'proccessStatus',
      width: '20%',
      setColumnStyle: 'text-center',
      render: (value, row) => {
        switch (value) {
          case '계약자 작성중':
            return (
              <>
                <span className="status-label writing">
                  {row.effectiveYn === 'Y'
                    ? '계약자 작성중'
                    : '계약자 작성 미완료'}
                </span>

                {row.effectiveYn === 'Y' && (
                  <>
                    <br />
                    <button
                      type="button"
                      className="btn-view3 mgt-5"
                      onClick={() => clickListEvent('urlReSend', row)}
                    >
                      계약자 URL
                    </button>
                  </>
                )}
              </>
            );
          case '피보험자 작성중':
            return (
              <>
                <span className="status-label writing">
                  {row.effectiveYn === 'Y'
                    ? '피보험자 작성중'
                    : '피보험자 작성 미완료'}
                </span>

                {row.effectiveYn === 'Y' && (
                  <>
                    <br />
                    <button
                      type="button"
                      className="btn-view3 mgt-5"
                      onClick={() => clickListEvent('urlReSend', row)}
                    >
                      피보험자 URL
                    </button>
                  </>
                )}
              </>
            );
          case '작성중':
            return (
              <>
                <span className="status-label writing">
                  {row.effectiveYn === 'Y' ? '작성중' : '작성 미완료'}
                </span>

                {row.effectiveYn === 'Y' && (
                  <>
                    <br />
                    <button
                      type="button"
                      className="btn-view3 mgt-5"
                      onClick={() => clickListEvent('urlReSend', row)}
                    >
                      계약자 URL
                    </button>
                  </>
                )}
              </>
            );
          case '설계사 작성중':
            return (
              <>
                <span className="status-label writing">
                  {row.effectiveYn === 'Y'
                    ? '설계사 작성중'
                    : '설계사 작성 미완료'}
                </span>

                {row.effectiveYn === 'Y' && (
                  <>
                    <br />
                    <button
                      type="button"
                      className="btn-view3 mgt-5"
                      onClick={() => clickListEvent('urlReSend', row)}
                    >
                      설계사 URL
                    </button>
                  </>
                )}
              </>
            );
          case '친권자':
            return (
              <>
                <span className="status-label writing">
                  {row.effectiveYn === 'Y' ? '작성중' : '작성 미완료'}
                </span>

                {row.effectiveYn === 'Y' && (
                  <>
                    <br />
                    <button
                      type="button"
                      className="btn-view3 mgt-5"
                      onClick={() => clickListEvent('urlReSend', row)}
                    >
                      친권자 URL
                    </button>
                  </>
                )}
              </>
            );
          default:
            // 청약접수
            return <span className="status-label receipt">{value}</span>;
        }
      },
    },
    {
      title: '고객명',
      dataIndex: 'ownerName',
      key: 'ownerName',
      width: '25%',
      align: 'center',
      render: (value, row) => {
        // 계피 동일
        if (row.isSameOwnerInsureYn === 'Y') {
          return <span className="customer text-center">{value ?? ''}</span>;
        } else {
          return (
            <>
              <span className="customer text-center">
                {' '}
                계약자 : {value ?? ''}
              </span>
              <br />
              <span className="customer text-center">
                {' '}
                피보험자 : {row.insuredName ?? ''}
              </span>
            </>
          );
        }
      },
    },
    {
      title: '상품명/증권번호',
      dataIndex: 'productName',
      key: 'productName',
      width: '40%',
      render: (value, row) => {
        return (
          <div className="t-row-wrap">
            {/* 20230913 회사별 아이콘 삭제 */}
            {/* <span
                className={`ico2 ${
                  row.compCd === PRODUCT_COMP_CD.kb ? 'ico-k' : 'ico-p'
                }`}
              ></span> */}
            <div className="insu-tit">
              {row.isRepulishYn === 'Y' && (
                <span className="type-label">재발행</span>
              )}
              {row.convYn === 'Y' && (
                <span className="type-label">{`전환`}</span>
              )}
              {value}
            </div>
            <div className="plan-info5">
              <ul>
                <li>
                  보험료 :{row.primium}
                  <span className="pdl-14">증번 : {row.newbizPolicyNo}</span>
                </li>
                <li>모바일청약발행번호 : {row.applicationNo}</li>
              </ul>
            </div>
          </div>
        );
      },
    },
  ];

  const sortingOption = [
    {
      sortBy: 'sendDate',
      order: searchParams.sort === 'desc' ? 'desc' : 'asc',
    },
  ];

  // 오늘 날짜 인지 완료 건인지 확인
  // const getIsTodayAndDone = (row, currentDate) => {
  //   parse, isSameYear, isSameMonth, isSameDay, getHours;
  //   const rowDate = parse(row.sendTime, 'yyyy-MM-dd', new Date());
  //   const currentHours = getHours(currentDate);

  //   const result = { isDone: false, isToday: false };

  //   // to do 작성이 완료된 경우(청약접수 상태) 데이터는 회색으로(흐리게) 표기하지 않는다
  //   if (row.cuStatus === 'DONE') result.isDone = true;

  //   // 오늘 날짜 이전 이고 오늘 23시가 지난 건은 회색
  //   if (
  //     currentHours < 23 || // 23시 까지만 작성
  //     isSameYear(rowDate, currentDate) || // 오늘 날짜만 작성 가능
  //     isSameMonth(rowDate, currentDate) ||
  //     isSameDay(rowDate, currentDate)
  //   ) {
  //     return true;
  //   }

  //   return result;
  // };

  return (
    <SatDataGrid
      columns={columns}
      dataSource={mobileOmniList}
      customStyleClass="bd-b-fix2"
      onScroll={onScroll}
      sortingOption={sortingOption}
      onSortChange={obj => onClickSortBtn(obj)}
      noDataRender={'검색결과가 없습니다.'}
      // setRowStyle={'text-center'}
      gridId={'omniGridScroll'}
      setRowStyle={row => {
        if (row.effectiveYn === 'N' && !(row.proccessStatus === '청약접수')) {
          return 'text-center disabled-tr';
        } else {
          return 'text-center';
        }
      }}
      useHeaderPinned
    />
  );
};

export default MobileOmniList;
